//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import { required, minLength } from 'vuelidate/lib/validators';

export default BaseCmsBlock.extend({
  name: 'SubscribeBlock',
  data() {
    return {
      errMessages: [],
      isModalOpen: false,
      formData: '',
      isPrivacyPolicy: true,
      mailingAgreement: true,
    };
  },
  watch: {
    formData() {
      this.errMessages = [];
      this.$v.$reset();
    }
  },
  validations: {
    formData: { required, minLength: minLength(6) },
  },
  methods: {
    async onSubcribe() {
      let form = {};
      this.errMessages = [],
        this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }
      if (this.formData.includes('@')) {
        form = {
          email: this.formData,
          group_id: '1',
          is_marketing: this.mailingAgreement,
        };
      }
      else {
        form = {
          phone: this.formData,
          group_id: '1',
          is_marketing: this.mailingAgreement,
        };
      }
      try {
        let res = await this.$api.agent.transport.post('subscribe', form);
        if (res) {
          this.isModalOpen = true;
          this.$nextTick(() => {
            this.$modal.show('subscribe-modal');
            this.formData = '';
            this.$v.$reset();
          });

          await this.$store.dispatch('mindbox/subscriptionsFooter', {
            group_id: '1',
            email: form?.email,
            phone: form?.phone,
          })
        }
      } catch (error) {
        this.errMessages = [];
        error.response.data.forEach((t) => {
          this.errMessages.push({
            error: t.message,
          });
        });
      }
    },
  },
});
